<div class="mif-login">
  @if (showOtpCheck) {
    <app-otp-check [prefilledUserId]="userId" [prefilledSessionId]="sessionId" [showCancel]="false" [centerSubmitButton]="true"></app-otp-check>
  }

  @if (showTooManyRequestsScreen) {
    <div class="request-rate-limit-screen">
      <p class="request-rate-limit-message">{{ tooManyRequestsMessage }}</p>
    </div>
  }

  @if (otpRequestFailed) {
    <p class="mif-login-message">Impossible d'envoyer le code de verification.</p>
  }
</div>